import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin, X } from 'lucide-react';
const buyers = [{
  name: 'Martina',
  city: 'Buenos Aires'
}, {
  name: 'Julieta',
  city: 'Córdoba'
}, {
  name: 'Lucía',
  city: 'Rosario'
}, {
  name: 'Sofía',
  city: 'Mendoza'
}, {
  name: 'Camila',
  city: 'Tucumán'
}, {
  name: 'Valentina',
  city: 'La Plata'
}, {
  name: 'Florencia',
  city: 'Mar del Plata'
}, {
  name: 'Agustina',
  city: 'Salta'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 8000);
    // Recurring interval — every 30 seconds
    const interval = setInterval(() => {
      showPopup();
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-229">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 max-w-sm bg-white rounded-lg shadow-xl border border-gray-100 p-4 flex items-start gap-4" data-id="element-230">
          <div className="bg-blue-100 p-2 rounded-full flex-shrink-0" data-id="element-231">
            <MapPin className="w-5 h-5 text-blue-600" data-id="element-232" />
          </div>
          <div className="flex-1 pr-4" data-id="element-233">
            <p className="text-sm text-gray-800 font-medium" data-id="element-234">
              <span className="font-bold" data-id="element-235">{currentBuyer.name}</span> de{' '}
              {currentBuyer.city}
            </p>
            <p className="text-xs text-gray-500 mt-0.5" data-id="element-236">
              Acaba de comprar el Megapack Élite
            </p>
            <p className="text-xs text-blue-600 font-medium mt-1" data-id="element-237">
              Hace 2 minutos
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-238">
            <X className="w-4 h-4" data-id="element-239" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}